<template>
  <tr ref="tr">
    <td v-if="$parent.$parent.$props.showIndex" class="order">{{ index }}</td>
    <slot></slot>
  </tr>
</template>

<script>
export default {
  name: "TrEx",
  data() {
    return {
      index: 0,
    };
  },
  mounted() {
    let units = this.$slots.default.filter((f) => f.tag);
    units.forEach((item) => {
      if (item.child != undefined) {
        item.child.$on("key", this.onKey);
        item.child.$on("selectedTd", (value) => {
          if (value) this.$emit("selected");
        });
      }
    });
    this.index = this.$refs.tr.rowIndex;
  },
  methods: {
    onKey(key, el) {
      if (key == "ArrowRight") {
        let nextEl = el.parentElement.nextElementSibling;
        if (nextEl && nextEl.children[0] && nextEl.children[0].focus)
          nextEl.children[0].focus();
      }
      if (key == "ArrowLeft") {
        let previousEl = el.parentElement.previousElementSibling;
        if (
          previousEl &&
          previousEl.children[0] &&
          previousEl.children[0].focus
        )
          previousEl.children[0].focus();
      }

      if (key == "ArrowDown") {
        this.$emit("key", "ArrowDown", el);
      }

      if (key == "ArrowUp") {
        this.$emit("key", "ArrowUp", el);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.order
  border 1px solid #e0e0e0
  color: #333
  font-size: 14px;
</style>
